import React, { useEffect  } from 'react';
import KMSApp from './common/components/KMSApp';
import { withAuthenticator, Button, Heading, Authenticator, TextField } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import './App.css';

function App() {
 
  return (
    <Authenticator.Provider>
      <KMSApp/>
    </Authenticator.Provider>
  
  );
}
const components={
  ForceNewPassword:{
    FormFields(){
      return (
        <>
          <TextField label="Password" name='password' type={'password'}  placeholder='Enter your password' />
          <TextField label="Confirm Password" name='confirm_password' type={'password'} placeholder='Please confirm your password'/>
        </>
      );
    }
  }
}
export default withAuthenticator(App,{signUpAttributes:[],hideSignUp:false});

// export default App;
